import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefixSegments } from '../../../constants'
import { ActionsCommon } from '../../common/ActionsCommon'

interface ActionsProps {
  selected: number
  onRemoveSelected(): void
}

export const SegmentsActions = ({
  selected,
  onRemoveSelected,
}: ActionsProps) => {
  const tRelative = useTranslationRankmi({
    prefix: prefixSegments,
  })
  return (
    <ActionsCommon
      label={tRelative('actions.label')}
      removeSelectedLabel={tRelative('actions.removeSelected', {
        count: selected,
      })}
      selected={selected}
      onRemoveSelected={onRemoveSelected}
    />
  )
}
